import { SemibigHeader, MediumHeader } from '@narvar/nth-bit-header';
import CheckMarkIcon from '@narvar/nth-bit-icon-check-mark';
import { RetailerTheme } from '@narvar/nth-hook-loma';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import React, { CSSProperties } from 'react';
import {
  StyledColumnDivider,
  StyledScheduledColumn,
  StyledScheduledContainer,
} from '../styled';
import ScheduledDeliveryInstructions from './ScheduledDeliveryInstructions';
import { useTranslator } from '../utils/translator';

dayjs.extend(advancedFormat);

interface ScheduledPanelProps {
  scheduledDate?: Date;
  featureName?: string;
  scheduledTime?: string;
  onRescheduleClick: () => void;
  localeLanguage?: string;
}

const ScheduledPanel = ({
  featureName,
  scheduledDate,
  onRescheduleClick,
  scheduledTime,
  localeLanguage,
}: ScheduledPanelProps) => {
  const { t } = useTranslator();
  const scheduleDeliveryScheduleDeliveryHeader = t(
    'You’ve Scheduled Your Delivery',
  );
  const scheduleDeliveryDateHeader = t('Date');
  const scheduleDeliveryTimeHeader = t('Time');

  const { bodytextDefaultNone: bodyText } = useTheme() as {
    [key in keyof RetailerTheme]: CSSProperties;
  };

  if (!scheduledDate) return null;

  return (
    <StyledScheduledContainer>
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <CheckMarkIcon />
        </div>
        <SemibigHeader as="h2">
          {scheduleDeliveryScheduleDeliveryHeader}
        </SemibigHeader>
      </div>
      <StyledColumnDivider />
      <StyledScheduledColumn>
        <div>
          <MediumHeader as="h3">{scheduleDeliveryDateHeader}</MediumHeader>
          <p style={{ ...bodyText }}>
            {dayjs(scheduledDate)
              .locale(localeLanguage || 'en')
              .format('dddd, MMMM Do, YYYY')}
          </p>
        </div>
        {scheduledTime && (
          <div>
            <MediumHeader>{scheduleDeliveryTimeHeader}</MediumHeader>
            <span style={{ ...bodyText }}>{scheduledTime}</span>
          </div>
        )}
      </StyledScheduledColumn>
      <StyledColumnDivider />
      <div>
        <ScheduledDeliveryInstructions
          featureName={featureName}
          rescheduleEnabled
          onRescheduleClick={onRescheduleClick}
        />
      </div>
    </StyledScheduledContainer>
  );
};

export default withThemeProvider(ScheduledPanel, {
  themeTokens: ['bodytextDefaultNone'],
});
